import { render, staticRenderFns } from "./AppModalEdital.vue?vue&type=template&id=ac12e6b8&scoped=true&lang=pug&"
import script from "./AppModalEdital.vue?vue&type=script&lang=js&"
export * from "./AppModalEdital.vue?vue&type=script&lang=js&"
import style0 from "./AppModalEdital.vue?vue&type=style&index=0&id=ac12e6b8&scoped=true&lang=scss&"
import style1 from "./AppModalEdital.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac12e6b8",
  null
  
)

export default component.exports